import { useContext, useEffect, useState } from "react";
import { classnames, getLastIndex, removeLastIndex } from "lib/helpers";
import { useDrop } from "lib/hooks";
import { rootNamespace } from "config";
import { TreeContext } from "pages/Editor";

function validateDrop(to, from) {
  // prevent drop inside self
  if (to.startsWith(from)) return false;
  return true;
}

export default function DropAnchor({ fill, path, style }) {
  const [hover, setHover] = useState(false);
  const drop = useDrop(path);
  const { publish, subscribe } = useContext(TreeContext);
  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let data = e.dataTransfer.getData("text/plain");
    try {
      data = JSON.parse(data);
      // prevent component moved inside self
      if (validateDrop(path, data.from)) drop(data);
    } catch (e) {}
    publish(rootNamespace, "HOVER");
  };
  const onDragOver = (e) => {
    e.preventDefault();
    const data = e.dataTransfer.getData("text/plain");
    if (data) {
      const { action, from } = JSON.parse(data);
      if (action === "MOVE") {
        // same position
        if (from === path) return;
        // if inside the same array
        if (removeLastIndex(from) === removeLastIndex(path)) {
          // prevent drop in last index
          if (getLastIndex(from) + 1 === getLastIndex(path)) return;
        }
      } else if (action === "ADD") {
      } else {
        // prevent other kinds of drop events
        return;
      }
    }
    publish(rootNamespace, "HOVER", path);
  };
  const onDragLeave = () => {
    publish(rootNamespace, "HOVER");
  };
  useEffect(() => {
    return subscribe(rootNamespace, "HOVER", (_path) => {
      setHover(_path === path);
    });
  }, [path, subscribe]);
  return (
    <div
      {...{ onDrop, onDragLeave, onDragOver }}
      className={classnames("da", { fp: fill, ap: !fill, hover: hover })}
      style={style}
    />
  );
}
